/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_fe5af7b0{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.root_fe5af7b0 .dropdown_fe5af7b0{margin-bottom:0;margin-left:5px}\n"}]);
export const root = "root_fe5af7b0";
export const dropdown = "dropdown_fe5af7b0";